import template from './creditworthinessMoreInfo.html';
import controller from './creditworthinessMoreInfo.controller';
import './creditworthinessMoreInfo.scss';

let creditworthinessMoreInfoComponent = {
  restrict: 'E',
  bindings: {
    information: '<',
  },
  template,
  controller
};

export default creditworthinessMoreInfoComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/creditworthiness/creditworthinessMoreInfo/creditworthinessMoreInfo.component.js